import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import Header from "./content/header"
import api from "../../services/api"
import ModalFatura from "./modulofinanceiro/modalfatura"
import ModalFaturaAdd from "./modulofinanceiro/modaladdfatura"

import Loader from "react-loader-spinner";

import CsvDownload from 'react-json-to-csv'

class IndexAdmin extends Component {

  state = {
    faturas:[],
    search:null,
    idmatricula:"",
    truemodaledit:"",
    truetoadd:false,
    dadoscsv:[],
    month:parseInt(new Date().getMonth())+1,
    ano:parseInt(new Date().getFullYear()),
    loaded:false
  }

  
  async componentDidMount(){
    if(this.props.match.params.idmatricula){
      this.setState({
        idmatricula:this.props.match.params.idmatricula
      })
      this.loadfaturas(this.props.match.params.idmatricula, this.state.month,this.state.ano);
    }else{
      this.loadfaturas(this.state.idmatricula, this.state.month,this.state.ano);
    }


  }
  

  async verboleto(idfaturaverboleto){
    const response = await api.post("/admin/fatura/verboleto", {id:idfaturaverboleto});

    window.open(response.data.status_request.bank_slip.url_slip_pdf);

    
  }
  
  async loadfaturas(idmatricula, month,ano){

    this.setState({loaded:false,
      dadoscsv:[],
      faturas:[]
    })

    const response = await api.post("/admin/faturas/idmatricula", {idmatricula, month,ano});
    const responsecsv = await api.post("/admin/faturascsv/idmatricula", {idmatricula, month,ano});

    if(response.data){
      this.setState({
        faturas:response.data,
        loaded:true,
      })
    }

    if(responsecsv.data){
      this.setState({
        dadoscsv:responsecsv.data
      })
    }


    

  }


  async shouldComponentUpdate(nextProps, nextState){
    
    if(this.state.idmatricula!==nextState.idmatricula || this.state.month!==nextState.month || this.state.ano!==nextState.ano){
      nextState.loaded=true;
      this.loadfaturas(nextState.idmatricula, nextState.month,nextState.ano);
     
    }
    

    if(this.state.idfaturaverboleto!==nextState.idfaturaverboleto){
      this.verboleto(nextState.idfaturaverboleto);
    }

    

    return true;
  }


  render() {
    return (
      <React.Fragment>
          <Header />
          <div class="container col-lg-11 p-4">   
          <h4>Faturas Geradas</h4>     

<ModalFatura truemodaledit={this.state.truemodaledit} />

<ModalFaturaAdd truetoadd={this.state.truetoadd} />

          <br></br>
 <input type="text" id="myInput" defaultValue={this.props.match.params.idmatricula} onChange={e => this.setState({ idmatricula: e.target.value })}  placeholder="Código Matricula" />
 <button type="button" class="btn btn-light btn-sm">Pesquisar</button>

<br></br>

{
  this.state.idmatricula && 
  <a class="btn btn-primary btn-md" onClick={e => this.setState({ truetoadd: this.state.idmatricula, truemodaledit:"" })}>Gerar Boleto</a>

}
<CsvDownload children="Extrair Faturas" class="btn btn-dark btn-md" disabled={this.state.loaded==false} filename={"relatoriofaturas"+new Date().getDate()+'-'+new Date().getMonth()+'-'+new Date().getFullYear()+"_Mes_"+this.state.month+".csv"} data={this.state.dadoscsv} />

<br />
        
<br />
          <center>
            <label id="mes">Vencimento no mês </label>
            <br></br>
            <select id="mes" onChange={e => this.setState({ month: parseInt(e.target.value) })}>
                <option value={0} >Todos os meses</option>
                <option value={1} selected={this.state.month==1}>Janeiro</option>
                <option value={2} selected={this.state.month==2}>Fevereiro</option>
                <option value={3} selected={this.state.month==3}>Março</option>
                <option value={4} selected={this.state.month==4}>Abril</option>
                <option value={5} selected={this.state.month==5}>Maio</option>
                <option value={6} selected={this.state.month==6}>junho</option>
                <option value={7} selected={this.state.month==7}>julho</option>
                <option value={8} selected={this.state.month==8}>agosto</option>
                <option value={9} selected={this.state.month==9}>setembro</option>
                <option value={10} selected={this.state.month==10}>outubro</option>
                <option value={11} selected={this.state.month==11}>novembro</option>
                <option value={12} selected={this.state.month==12}>dezembro</option>
            </select>
            <select onChange={e => this.setState({ ano: parseInt(e.target.value) })}>
              <option value={2019} selected={this.state.ano==2019}>2019</option>
              <option value={2020} selected={this.state.ano==2020}>2020</option>
              <option value={2021} selected={this.state.ano==2021}>2021</option>
              <option value={2022} selected={this.state.ano==2022}>2022</option>
              <option value={2023} selected={this.state.ano==2023}>2023</option>
              <option value={2024} selected={this.state.ano==2024}>2024</option>
              <option value={2025} selected={this.state.ano==2025}>2025</option>
            </select>
          </center> 
 <table class="table  table-stripe table-bordered">
  <thead>
  <tr>
      <th >Nº Fatura

    </th>
    <th >Nº Mat

    </th>
      <th >Aluno

    </th>
    <th>Curso

    </th>
      <th>Valor Inteiro

      </th>
      <th >Valor c/Desconto

      </th>

      <th >Vencimento:

      </th>
      <th >Status

      </th>
      <th>Ação

      </th>


    </tr>
  </thead>
  <tbody>
 
  {this.state.faturas.map(el => (
    <tr>
    <td>{el.id}</td>
    <td>{el.matriculas.id}</td>
    <td>{el.matriculas.user.dados_users.nomecompleto}</td>
    <td>{el.matriculas.pos_curso.nome}</td>
    <td>R${parseFloat(el.valorinteiro).toFixed(2)}</td>
    <td>R${parseFloat(el.valorinteiro-el.valordesconto).toFixed(2)}
    </td>
    
    <td>{el.diavencimento}
    </td>

     { el.status==0 && <td>Cancelado</td>}
     { el.status==1 && <td>Não Pago</td>}
     { el.status==2 && <td>Pago</td>}
     { el.status==3 && <td ><a class="text-red">Reembolsado</a></td>}

     <td>
     <a class="btn btn-info btn-md" onClick={e => this.setState({ idfaturaverboleto: el.id })}>Ver Boleto</a>
     <a class="btn btn-primary btn-md" href="#" onClick={e => this.setState({ truemodaledit: el.id, truetoadd:false })}>Editar</a>
    </td>
    </tr>
    
  ))}
  </tbody>
</table>
<Loader
    className="d-flex justify-content-center"
    type="TailSpin"
    color="#00BFFF"
    height={100}
    width={100}
    visible={this.state.loaded==false} //3 secs
    />

          </div>

      </React.Fragment>
       
    );
  }
}

export default withRouter(IndexAdmin);


// WEBPACK FOOTER //
// ./src/pages/Admin/faturas.js